<template>
  <div class="sidebar filter">
    <div class="row">
      <div class="col">
        <form class="sidebar-form ic-form promo-filter">
          <h3>
            <strong>Filtruj</strong> oferty
          </h3>
          <div class="form-check mb-3">
            <input class="form-check-input large-checkbox" type="checkbox" value="" id="flexCheckDefault1">
            <label class="form-check-label" for="flexCheckDefault1">
              Lorem  dolor sit amet
            </label>
          </div>
          <div class="form-check mb-3">
            <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault2">
            <label class="form-check-label" for="flexCheckDefault2">
              Lorem ipsum dolor sit
            </label>
          </div>
          <div class="form-check mb-3">
            <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault3">
            <label class="form-check-label" for="flexCheckDefault3">
              Lorem ipsum dolor sit amet  dolor sit amet
            </label>
          </div>
          <div class="form-check mb-3">
            <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault4">
            <label class="form-check-label" for="flexCheckDefault4">
              Lorem ipsum
            </label>
          </div>
          <h3>
            <strong>Przedział</strong> cenowy
          </h3>
          <div class="mb-3">
            <input type="range" class="form-range" min="0" max="500" step="1" v-model="maxPrice" id="customRange3">
            <label for="customRange3" class="form-label d-flex justify-content-between color-dark-gray">
              <span>1 zł</span>
              <span class="max" id="max-price">{{maxPrice}} zł</span>
            </label>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'section-sidebar-filter',
  data() {
    return {
      maxPrice: 500
    }
  }
}
</script>